module.exports = __webpack_public_path__ + "static/media/izmeritelnye_preobrazovatelikz.c8c01904.pdf";